import { FC } from "react";
import Image from "next/image";
import Link from "components/Hyperlink";
import type {
  TemplateIntegrationListingFragment,
  TemplateTemplateIntegrationsCollection,
  TemplateTemplateWidgetsCollection,
  TemplateWidgetListingFragment,
} from "contentful/gql/graphql";
import { assetFragment } from "contentful/fragments";
import { getFragmentData } from "contentful/gql";
import Hyperlink from "components/Hyperlink";

const IconList = ({ list }: { list: any }) => {
  let listData = list as TemplateTemplateIntegrationsCollection["items"] | TemplateTemplateWidgetsCollection["items"];
  return (
    <div className="flex flex-wrap gap-2xs">
      {listData.map((li) => {
        if (li?.__typename === "TemplateIntegration") {
          return (
            <Hyperlink key={li.title} href={`/integration/${li.slug}`} className="block h-lg w-auto">
              <Image
                src={li.integrationIcon?.url || ""}
                alt={li.integrationIcon?.title || "Integration icon"}
                className="h-full w-auto"
                width={li.integrationIcon?.width || 0}
                height={li.integrationIcon?.height || 0}
              />
            </Hyperlink>
          );
        } else if (li?.__typename === "TemplateWidget") {
          return (
            <Hyperlink
              key={li.title}
              href={li.externalLink ? li.externalLink : "https://docs.appsmith.com/reference/widgets/"}
              className="block rounded border border-secondary-light-100 bg-secondary-light-50 p-4xs"
            >
              <Image
                src={li.widgetIcon?.url || ""}
                alt={li.widgetIcon?.title || "Widget icon"}
                className="h-md w-md"
                width={li.widgetIcon?.width || 0}
                height={li.widgetIcon?.height || 0}
              />
            </Hyperlink>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default IconList;
